<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <form [formGroup]="editForm" enctype="multipart/form-data">
      <div class="form-group">
        <label>اســـم الدورة التدريبية</label>
        <input
          type="text"
          [class.is-invalid]="tittle?.invalid && tittle?.touched"
          formControlName="tittle"
          class="form-control"
        />
        <div *ngIf="tittle?.errors && tittle?.touched">
          <small class="text-danger" *ngIf="tittle?.errors?.required"
            >اسم الدورة التدريبية مطلوب</small
          >
        </div>
      </div>

      <div class="form-group">
        <label>الوصـــف</label>
        <textarea
          [class.is-invalid]="description?.invalid && description?.touched"
          formControlName="description"
          class="form-control"
        ></textarea>
        <div *ngIf="description?.errors && description?.touched">
          <small class="text-danger" *ngIf="description?.errors?.required"
            >الوصـــف مطلوب</small
          >
        </div>
      </div>
      <div class="form-group">
        <label>القســـم</label>
        <select class="custom-select" formControlName="categoryID">
          <option
            *ngFor="let category of categories"
            value="{{ category._id }}"
          >
            {{ category.Title }}
          </option>
        </select>
      </div>


      <div class="form-group row d-flex justify-content-between align-items-center mt-3">
        <div class="progress col-lg-3 mt-3" *ngIf="existingFile">
          <div
            class="progress-bar progress-bar-striped bg-danger"
            attr.aria-valuenow="{{ progress }}"
            aria-valuemin="0"
            aria-valuemax="100"
            [ngStyle]="{ width: progress + '%' }"
          >
            {{ progress }}%
          </div>
        </div>

        <label class="btn btn-default col-lg-3 mt-3">
          <input type="file" (change)="chooseFile($event)" />
        </label>

        <img class="img-fluid col-lg-3 mt-3"
          src="https://khairokom-uploadfiles.azurewebsites.net/files/{{fileName}}"            
        />

        <button
          class="upload btn btn-primary col-lg-2 mt-3"
          [disabled]="!chosenFiles"
          (click)="upload()"
        >
          رفع الصـــورة
        </button>

        <div class="alert alert-light">{{ msg }}</div>
      </div>

      <input
        type="submit"
        class="update btn btn-primary"
        value="تعديــــل"
        (click)="submit()"
      />
    </form>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>
